<div class="warp-definitions" [style.background]="secondaryColor$ | async"
    [style.border-bottom]="'10px solid ' + (mainColor$ | async)"
    [style.backgroundImage]="coverImage$()?'url(' + coverImage$() + ')':'none'">
    <div class="warp-logo">
        <que-logo-display></que-logo-display>
        <div class="circle absolute" *ngIf="isEdit" [style.background]="mainColor$ | async">
            <que-mini-add-logo></que-mini-add-logo>
        </div>
    </div>
    <div class="warp-name" #editTrigger>
        <div class="name" [ngClass]="{coverImage:coverImage$()}" *ngIf="isEdit else titleNoEdit">
            <div>
                <div class="warp-input" [ngClass]="{'open':openEditNow,'show-error':showMaxLengthError}">
                    <img *ngIf="openEditNow" src="/assets/images/definitions/reset-input.svg" class="custom-svg"
                        (click)="cleanTitle();openEditNow=false" />
                    <img *ngIf="!openEditNow" src="/assets/images/edit.svg" class="custom-svg"
                        (click)="openEditNow=true" />
                    <!-- <p class="no-margin" *ngIf="name.value else placeholder">{{name.value}}</p> -->
                    <input [size]="(name.value?.length??0)>0?(name.value?.length!+3):23"
                        oninput="this.size = this.value.length>0?this.value.length+3:23"
                        placeholder="{{'header.questinnaireName' | translate}}" [formControl]="name">
                    <!-- [maxLength]="50" -->

                    <div class="tooltip top">
                        <div class="warp">
                            <p translate>showMaxLengthError70</p>
                        </div>
                    </div>
                </div>

            </div>
            <div class="warp-select" #trigger>
                <div class="folder" *ngIf="currentCategory$() as c" (click)="isMenuOpen=true">
                    <img src="/assets/images/definitions/folder.svg" class="folder-img">
                    <p translate [translateParams]="{ category: c}">
                        grid.categoryName
                    </p>

                    <img src="/assets/images/steps/dropdown.svg" class="download-img" />
                </div>
            </div>

            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
                cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="isMenuOpen=false"
                [cdkConnectedOverlayOpen]="isMenuOpen" [cdkConnectedOverlayPositions]="positonArea">
                <div class="overlay-warp">
                    <div *ngFor="let c of categories$ | async " class="item" (click)="updateSelection(c.id)">
                        <p translate [translateParams]="{ category: c}">
                            grid.categoryName
                        </p>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>

    <div class="editColors" #colorstrigger>
        <div class="circle" *ngIf="isEdit" (click)="isColorsPanelOpen=true" [style.background]="mainColor$ | async">
            <img src="/assets/images/new-definitions/colors.svg">
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="colorstrigger" [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
        (backdropClick)="isColorsPanelOpen=false" [cdkConnectedOverlayOpen]="isColorsPanelOpen"
        [cdkConnectedOverlayPositions]="positonArea">
        <form class="overlay-warp" [formGroup]="colorForm">
            <p translate class="color-title">definitions.color-setting</p>
            <div class="color">
                <div class="color-display" (click)="mainColor.click()"
                    [style.backgroundColor]="colorForm.controls.mainColor.value"></div>
                <label translate>definitions.color.mainColor</label>
                <input class="display-none" type="color" #mainColor formControlName="mainColor">
            </div>
            <div class="color">
                <div class="color-display" (click)="secondaryColor.click()"
                    [style.backgroundColor]="colorForm.controls.secondaryColor.value"></div>
                <label translate>definitions.color.secondaryColor</label>
                <input class="display-none" type="color" #secondaryColor formControlName="secondaryColor">
            </div>
            <div class="color">
                <div class="color-display" (click)="backColor.click()"
                    [style.backgroundColor]="colorForm.controls.backColor.value"></div>
                <label translate>definitions.color.backgroundColor</label>
                <input class="display-none" type="color" #backColor formControlName="backColor">
            </div>
            <div class="border-top">
                <p translate class="color-title">definitions.binding-setting</p>
            </div>
            <div class="file-upload">
                <input type="file" id="file-input" #addFile (change)="onFileSelected($event);addFile.value=''" hidden
                    accept="image/*">
                <label for="file-input" class="file-label">
                    <span translate>definitions.binding-img</span>
                    <img src="/assets/images/definitions/add-binding.svg" alt="icon" class="upload-icon">
                </label>
                <div *ngIf="coverName$()" class="file-name">
                    <span>{{ coverName$() }}</span>
                    <img src="/assets/images/definitions/remove-binding.svg" alt="icon" class="upload-icon pointer"
                        (click)="clearFile()">
                </div>
            </div>

            <div class="reset pointer">
                <p (click)="reset()" translate>definitions.reset</p>
            </div>
        </form>
    </ng-template>
</div>


<ng-template #titleNoEdit>
    <div class="warp-name">
        <div class="name" [ngClass]="{coverImage:coverImage$()}">
            <div class="warp-input no-border">
                <p *ngIf="name.value!='' && name.value != null else placeholder">{{name.value}}</p>
            </div>
            <div class="warp-select" *ngIf="currentCategory$() as c">
                <div class="folder" *ngIf="c.id !== 0">
                    <img src="/assets/images/definitions/folder.svg">
                    <p class="no-margin" translate [translateParams]="{ category: c}">
                        grid.categoryName
                    </p>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #placeholder>
    <p class="no-margin" translate>header.questinnaireName</p>
</ng-template>
<ng-template #divPlaceholder>
    <div class="divPlaceholder">

    </div>
</ng-template>